module.exports = __webpack_public_path__ + "static/media/Амарант България ООД.9e654b8f.pdf";